"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clamp = void 0;
/* eslint-disable no-nested-ternary */
function clamp(value, min, max) {
    return min < max
        ? (value < min ? min : value > max ? max : value)
        : (value < max ? max : value > min ? min : value);
}
exports.clamp = clamp;
//# sourceMappingURL=clamp.js.map